export default __webpack_public_path__ + "static/media/heart-plate-knife-and-fork.8e1a2318.svg";